import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LockService } from './lock.service';
import { TimerService } from './timer.service';

@Injectable({
  providedIn: 'root'
})
export class PreloadService {

  private character: string[] = [
    "assets/images/characaters.png",
    "assets/images/loading.png",
    "assets/images/character.png",
    "assets/images/digits.png",
  ]
  private images: string[] = [];
  constructor(private lockService: LockService, private timerService: TimerService) {
    this.images = [];
    this.images = this.images.concat(this.character);
    this.images = this.images.concat(this.lockService.getImages());
    this.images = this.images.concat(this.timerService.getImages());
  }

  public progress: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private _progressVal: number = 0;
  public preload() {
    this._progressVal = 0;
    let step = Math.ceil(100 / (this.images.length ? this.images.length : 1));
    let promises: Promise<string>[] = [];
    this.images.forEach(i => {
      promises.push(
        new Promise(() => {
          const img = new Image();
          img.src = i;
          img.addEventListener("load", (e) => {
            this.addProgress(step);
          })
          img.addEventListener("error", (e) => {
            this.addProgress(step);
          })
        }));
    });
    ;
  }

  public addProgress(step: number) {
    this._progressVal += step;
    this.progress.next(this._progressVal);

  }
}
